import { render, staticRenderFns } from "./Fakultas.vue?vue&type=template&id=0f993f9c&"
import script from "./Fakultas.vue?vue&type=script&lang=js&"
export * from "./Fakultas.vue?vue&type=script&lang=js&"
import style0 from "./Fakultas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports